// import MobileNavigationBar from '@component/mobile-navigation/MobileNavigationBar';
// import Sticky from '@component/sticky/Sticky';
// import Topbar from '@component/topbar/Topbar';
import { Link as RouterLink, Outlet } from 'react-router-dom';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import React, { FC, Fragment, useCallback, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import Section10 from '../components/landing/Section10';

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0)
  }
}));

export default function AppLayout({ children }) {
  const [isFixed, setIsFixed] = useState(false);

  // console.log('children in AppLayout', children);
  const toggleIsFixed = useCallback((fixed) => {
    setIsFixed(fixed);
  }, []);

  return (
    <>
      <HeaderStyle>
        <title>ZIMTA</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </HeaderStyle>
      {/* <Topbar /> */}
      {/* <Sticky fixedOn={0} onSticky={toggleIsFixed}> */}
      <Header isFixed={isFixed} />
      {/* </Sticky> */}
      {/* <div className="section-after-sticky">{children}</div> */}
      <Outlet />
      {/* {children} */}
      {/* <Section10 /> */}
      {/* <MobileNavigationBar /> */}
      {/* <Footer /> */}
    </>
  );
}
